/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_YearlyInputs */

const en_landing_pricing_yearly = /** @type {(inputs: Landing_Pricing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly`)
};

const zh_landing_pricing_yearly = /** @type {(inputs: Landing_Pricing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年付`)
};

/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Landing_Pricing_YearlyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_yearly = /** @type {((inputs?: Landing_Pricing_YearlyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_YearlyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_yearly(inputs)
	return zh_landing_pricing_yearly(inputs)
});
export { landing_pricing_yearly as "landing.pricing.yearly" }